import React, { useState, useEffect } from "react";
import "./calendar-styles.css";
import "./info-styles.css";
import "../theme/app-styles.css";
import "../components/selection-button-styles.css";

import Footer from "../components/Footer";
import { Student, DEFAULT_STUDENT } from "../data/candidates";
import StudentList from "../components/StudentList";


import {
  RadioGroupChangeEventDetail,
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButton,
  IonTitle,
  IonList,
  IonItem,
  IonRadioGroup,
  IonRadio,
  IonModal,
  useIonViewDidEnter,
} from "@ionic/react";

const MAX_FILE_SIZE = 4100000;
const ENABLE_UPLOADS = true;
const ALLOWED_FILE_TYPES = ["text/plain", "application/pdf", "image/jpeg", "image/png"];


import { ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase";
import { IonRadioGroupCustomEvent } from "@ionic/core";

const UploadPage: React.FC = () => {
  const [fileUpload, setFileUpload] = useState<File | null>(null);
  const [fileToCheck, setFileToCheck] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadType, setUploadType] = useState("none");
  const [candidate, setCandidate] = useState<Student>(DEFAULT_STUDENT);
  const [showModal, setShowModal] = useState(false);
  const [blockUploadButton, setBlockUploadButton] = useState(false);

 
  useIonViewDidEnter(() => {
    clearState();
  });

  useEffect(()=>{
    console.log(candidate);
  }, [candidate]);

  useEffect(() => {
    if(fileToCheck !== null) {
      console.log("Checking file size")
        if (fileToCheck.size > MAX_FILE_SIZE) {
          alert(
            "ERROR: File is too large. Maximum size is 4M bytes."
            
          );
    
          window.location.reload();
        }
        console.log("Chaeking file type")
        if (!ALLOWED_FILE_TYPES.includes(String(fileToCheck.type))) {
          alert(
            "ERROR: File type is not recognized. Only text, PDF, PNG and JPEG files are accepted."
          );
          window.location.reload();
        }
        setFileUpload(fileToCheck);
    }
  }, [fileToCheck]);

  useEffect(() =>
  {
    console.log(fileToCheck?.name);
  }, [fileUpload]);



  function clearState() {
    setFileUpload(null);
    setErrorMessage("");
    setUploadType("none");
    setCandidate(DEFAULT_STUDENT);
    setBlockUploadButton(false);
  }

  const uploadEnable =
    uploadType !== "none" &&
    candidate.first !== DEFAULT_STUDENT.first &&
    fileUpload !== null &&
    !blockUploadButton;


  function processFile(event: React.ChangeEvent<HTMLInputElement>) {
    console.log(event.target.files);
    if (event.target.files?.length !== 0) {
      setFileToCheck(event.target.files![0]);
    }
  }

  
  function uploadFile() {
      setBlockUploadButton(true);
      const fileDir = `${candidate.last.toUpperCase()}_${candidate.first.toUpperCase()}`;
        //candidate.last.toUpperCase() + "_" + candidate.first.toUpperCase();
      if (fileUpload === null) {
        setErrorMessage("Error: No file selected. Please select a file.");
        return;
      }
      const lastDotIndex = fileUpload.name.lastIndexOf('.');
      if (lastDotIndex === -1 || lastDotIndex === 0) {
           setErrorMessage("Error: File has no extension.");
        return;
      }

      const extension = fileUpload.name.substring(lastDotIndex);
      const fileRef = ref(storage, `${fileDir}/${uploadType}_${Date.now()}${extension}`);
      console.log("about to upload bytes");
      uploadBytes(fileRef, fileUpload).then(() => {
        alert("File has been uploaded");
        window.location.reload();
      });
  
  }

  function saveCandidateAndDismissModal(candidate: Student) {
    if (candidate) {
      setCandidate(candidate);
    }
    setShowModal(false);
  }

  function handleRadioChange(
    event: IonRadioGroupCustomEvent<RadioGroupChangeEventDetail>
  ) {
    console.log(event.target.value);
    setUploadType(event.target.value);
  }

  return (
    <IonPage className="info-page">
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle className="ion-text-center">File Uploads</IonTitle>
        </IonToolbar>
      </IonHeader>

     {ENABLE_UPLOADS && <IonContent className="background-image">
        <div className="content-container">
          <section>
            <p className="body-text">
             You may use this page to upload the documentation that we have
              requested. Alternatively, you may bring copies of the documents to
              class and give it to your table leader.
            </p>
            <p className="body-text">
              {" "}
              As a reminder, the following is a list of the required
              documentation depending upon your specific situation:
            </p>
            <ul className="bullet-list">
              <li className="bullet-text">
                <strong>Unbaptized Inquirers/Catecumens:</strong> Please upload
                a copy of your legal birth certificate and the Attestation Form
                completed by your sponsor.
              </li>
              <li className="bullet-text">
                <strong>
                  Baptized Catholics receiving Confirmation and/or First Holy
                  Communion:
                </strong>{" "}
                Please upload a copy of the <span style={{textDecoration: "underline"}}>front side and back side</span> of your Baptism Certificate and the
                Attestation Form completed by your sponsor. &nbsp;
                <em>
                  Note: Your baptism certificate must be a recent copy (dated no
                  earlier than September 2025). You should contact the parish
                  where you were baptized and request a copy. <span style={{textDecoration: "underline"}}>Make sure you request a certificate &quot;WITH NOTATIONS&quot;.</span>
                </em>
              </li>
              <li className="bullet-text">
                <strong>Baptized Christian wishing to enter the Church:</strong>{" "}
                Please upload &quot;proof&quot; of your baptism, a copy of your
                your legal birth certificate, and the Attestation Form completed
                by your sponsor. Ideally the &quot;proof&quot; of your baptism
                is a copy of a baptism certificate. Alternatively, it could be
                an email from the church of your baptism or a letter/emaill from
                a person who witnessed your baptism.
              </li>
            </ul>
          </section>
          <div>
            <h1 className="upload-title">UPLOAD DOCUMENTS HERE</h1>
          </div>

          <div>
            <IonList style={{ width: "100%" }}>
              <IonItem>
                <p className="upload-steps-text">
                  Step #1: Select Candidate&apos;s Name
                </p>
              </IonItem>
              <IonItem className="candidate-select-item">
                <IonButton
                  className="select-button"
                  onClick={() => setShowModal(prev => !prev)}
                >
                  Candidate&apos;s Name
                </IonButton>
              </IonItem>
              <IonItem className="candidate-select-item">
                <p className="upload-steps-text" style={{fontStyle: "italic", color: "red"}}>{`${candidate.first} ${candidate.last}`}</p>
                
              </IonItem>
            </IonList>
            <IonList style={{ width: "100%" }}>
              <IonItem>
                <p className="upload-steps-text">
                  Step #2: Upload document (must be .txt, .jpeg, .png, or .pdf)
                </p>
              </IonItem>
              <IonItem>
                <input type="file" onChange={(event) => processFile(event)}  />
              </IonItem>
            </IonList>
            <IonList style={{ width: "100%" }}>
              <IonItem>
                <p className="upload-steps-text">
                  Step #3: Select the type of document.
                </p>
              </IonItem>
              <IonRadioGroup onIonChange={(e) => handleRadioChange(e)}>
                <IonItem>
                  <IonRadio
                    labelPlacement="end"
                    value="bapCert1"
                    justify="start"
                  >
                    Catholic Baptism Certificate (Front)
                  </IonRadio>
                </IonItem>
                <IonItem>
                  <IonRadio
                    labelPlacement="end"
                    value="bapCert2"
                    justify="start"
                  >
                    Catholic Baptism Certificate (Back side)
                  </IonRadio>
                </IonItem>
                <IonItem>
                  <IonRadio labelPlacement="end" value="proof" justify="start">
                    Proof of Baptism (Non-Catholic Christian)
                  </IonRadio>
                </IonItem>
                <IonItem>
                  <IonRadio
                    labelPlacement="end"
                    value="birthCert"
                    justify="start"
                  >
                    Birth Certificate
                  </IonRadio>
                </IonItem>
                <IonItem>
                  <IonRadio
                    labelPlacement="end"
                    value="sponsorForm"
                    justify="start"
                  >
                    Sponsor Attestation Form
                  </IonRadio>
                </IonItem>
              </IonRadioGroup>
            </IonList>
             <IonList style={{ width: "100%" }}>
              <IonItem>
                <p className="upload-steps-text">
                  Step #4: Upload the document.
                </p>
              </IonItem>
             
              <IonItem>
                <IonButton
                  className="select-button"
                  onClick={() => uploadFile()}
                  disabled={!uploadEnable}
                >
                  {" "}
                  Upload File
                </IonButton>
              </IonItem>
              <IonItem>
              <p style={{ color: "red" }}>{`\n${errorMessage}`}</p>

              </IonItem>

            </IonList>
          </div>
        </div>
      </IonContent>}
      {!ENABLE_UPLOADS && <IonContent>
        <div className="no-upload-yet">
      
          <h2 style={{textAlign: "center", width: "50%"}}>Sorry, file uploads for this class are not yet activated. Please check back on September 15th. Thank you!</h2>
        </div>
      </IonContent>}
      <IonModal isOpen={showModal} backdropDismiss={true}>
        <StudentList dismiss={saveCandidateAndDismissModal} />
      </IonModal>
            
      <Footer />
    </IonPage>
  );
};

export default UploadPage;
